<template lang="pug">
server-data(
  :method="$api.courses.getCourseList"
  v-bind="serverDataAttrs"
  search-field-name="search[name]"
  v-slot="{ selectProps, search, loadMoreItems }"
)
  v-autocomplete-more.mr-2(
    :value="value"
    v-bind="{ ...selectProps, ...$attrs }"
    :items="selectProps.items"
    select-first
    :label="label"
    item-text="title"
    clearable rounded outlined
    return-object
    v-on="$listeners"
    @input="$emit('input', $event)"
    @update:search-input="search"
    @load-more-items="loadMoreItems"
    @keyup.enter="emitFilters"
  )
    template(v-slot:item="{ item, on, attrs }")
      v-list-item(
        :key="item.id"
        v-on="on"
        v-bind="attrs"
      )
        v-list-item-avatar
          v-img(
            :src="item.image_file_url || require('@/assets/course-sample.png')"
          )
        v-list-item-content
          v-list-item-title {{ item.title }}
          v-list-item-subtitle(v-if="item.type_activity") {{ item.type_activity.name }}
</template>

<script>
export default {
  name: 'SelectCourse',
  props: {
    value: { type: [Number, Object], default: null },
    serverDataAttrs: { type: Object, default: () => ({}) },
    label: { type: String, default: 'Выберите курс' },
  },
};
</script>
